import { Suspense } from 'react';
import { Loader } from './loader';

export function LoadingComponent(Component: any) {
  const WrappedComponent = (props: any) => (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );

  return WrappedComponent;
}

export function LoadingPage(Component: any) {
  const WrappedComponent = (props: any) => (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );

  return WrappedComponent;
}
